import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from 'react-toastify';

const safeString = (value, fallback = '') => (typeof value === 'string' ? value : fallback);

const copy = async (text) => {
  const t = safeString(text);
  if (!t) return;
  try {
    await navigator.clipboard.writeText(t);
    toast.success('Kopyalandı', { autoClose: 1200 });
  } catch (e) {
    toast.error('Kopyalanamadı', { autoClose: 2000 });
  }
};

/** Fikir metnini panoya kopyalar; metnin hemen bitiminde göstermek için Typography içine yerleştirin. */
export function IdeaTextCopyButton({ text }) {
  const t = safeString(text).trim();
  return (
    <Tooltip title={t ? 'Fikri kopyala' : 'Metin yok'}>
      <Box
        component="span"
        sx={{
          display: 'inline-flex',
          verticalAlign: 'text-bottom',
          ml: 0.15,
          position: 'relative',
          top: 1
        }}
      >
        <IconButton
          size="small"
          disabled={!t}
          onClick={(e) => {
            e.stopPropagation();
            void copy(t);
          }}
          sx={{ p: 0.2, minWidth: 28, minHeight: 28, color: '#6b5b4a' }}
          aria-label="Fikri kopyala"
        >
          <ContentCopyIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </Box>
    </Tooltip>
  );
}
